import { Button, Typography } from '@mui/material';
import logo from '../images/Logo_GLYNT_2020.png';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

function LogoutPage() {
  useSetTitle('Logout');
  const { loginWithPopup } = useAuth0();
  let navigate = useNavigate();

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '2em',
        }}
      >
        <img src={logo} alt="logo" width={300} />
      </div>
      <Typography variant="h4" align="center">
        You’ve been logged out from GLYNT.ai
      </Typography>
      <Typography variant="subtitle1" align="center">
        Click here to log in again
      </Typography>
      <div
        style={{
          margin: '1em 0',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            await loginWithPopup();
            navigate('/');
          }}
          data-cy="btn-login"
        >
          Login
        </Button>
      </div>
    </div>
  );
}

export default LogoutPage;
